import React, { useState, useEffect } from 'react';
import logo from '../images/logo-1.png';
import '../App.css';

function Loader() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 3000); // Simulate a 3-second loading time
    }, []);

    return (
        <>
            <div className={`loader-container ${!isLoading ? 'hidden' : ''}`}>
                <img src={logo} alt="Logo" className="loader-logo" />
            </div>
        </>
    );
}

export default Loader;
